import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

import FormGroupTypes from 'common/questionnaires/FormGroupTypes';

import FormResult from './FormResult';

const CombinedFormResult = (props) => {
  const availableFormTypes = useSelector(state => state.app?.onlineConfig?.formTypes);

  const isFormSupported = (type) => {
    const form = availableFormTypes.find(f => f.formType === type);
    return (form?.isEnabled === true && form?.isVisible === true);
  };

  const getFormGroupForms = formGroup => FormGroupTypes.find(f => f.key === formGroup);

  const getFirstFormSupported = (precedenceForm) => {
    if (!availableFormTypes) {
      return false;
    }
    if (precedenceForm.formType) {
      return isFormSupported(precedenceForm.formType);
    }
    if (precedenceForm.formGroup) {
      const matchedFormGroup = getFormGroupForms(precedenceForm.formGroup);
      let formGroupSupported = matchedFormGroup !== undefined;
      if (matchedFormGroup) {
        matchedFormGroup.formTypes.forEach((ft) => { formGroupSupported = formGroupSupported && isFormSupported(ft); });
      }
      return formGroupSupported;
    }
    return false;
  };

  const getMatchedForm = (precedenceForm) => {
    if (!availableFormTypes || !precedenceForm) {
      return null;
    }
    if (precedenceForm.formType) {
      return precedenceForm;
    }
    if (precedenceForm.formGroup) {
      const matchedFormGroup = getFormGroupForms(precedenceForm.formGroup);
      if (matchedFormGroup) {
        return {
          formGroup: matchedFormGroup,
          title: precedenceForm.title
        };
      }
    }
    return null;
  };

  const getFirstMatchForm = () => {
    if (!props) {
      return {};
    }

    const { precedence } = props;
    if (!precedence || !Array.isArray(precedence)) {
      return {};
    }
    return precedence.find(f => getFirstFormSupported(f));
  };

  const getProps = () => {
    if (!props) {
      return {};
    }

    const clonedProps = Object.assign({}, props);
    if (Object.prototype.hasOwnProperty.call(clonedProps, 'precedence')) {
      clonedProps.precedence = undefined;
    }

    const matchedForm = getFirstMatchForm();
    const formProps = getMatchedForm(matchedForm);
    return { ...clonedProps, ...formProps };
  };

  return (
    <FormResult { ...getProps() } />
  );
};

CombinedFormResult.propTypes = {
  precedence: PropTypes.arrayOf(PropTypes.shape())
};

CombinedFormResult.defaultProps = {
  precedence: null
};

export default CombinedFormResult;
